export default __webpack_public_path__ + "static/media/tel.b01790d5.svg";